class GameStyle {
  ACTION = 'ACTION';
  PENDING = 'PENDING';
  SETTLED = "SETTLED"
}

export default GameStyle;


